module.exports = __webpack_public_path__ + "static/media/wheel-bg@2x.d58e8d46.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_120/imgs/wheel-bg@2x.png
// module id = 1116
// module chunks = 0